import 'volto-comune-di-budrio/theme/_main.scss';

const applyConfig = (config) => {
  config.set('settings', {
    ...config.settings,
    siteProperties: {
      ...config.settings.siteProperties,
      siteTitle: 'Comune di Budrio',
      arLoginUrl: '/login?e=1',
      arLogoutUrl: '/logout?e=1',
    },
  });

  return config;
};

export default applyConfig;
